import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

interface AuthCallbackProps {
  onSuccess: () => void
}

export default function AuthCallback({ onSuccess }: AuthCallbackProps) {
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession()
        
        if (error) {
          setError(error.message)
          return
        }

        if (session) {
          // Clear the URL hash/params and redirect
          window.history.replaceState({}, '', '/')
          onSuccess()
        } else {
          setError('Session non trouvée. Veuillez réessayer.')
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Une erreur est survenue')
      }
    }

    handleCallback()
  }, [onSuccess])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md px-4">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <p className="text-gray-900 font-medium mb-2">Erreur de connexion</p>
          <p className="text-sm text-gray-600 mb-4">{error}</p>
          <a 
            href="/"
            className="inline-block px-4 py-2 bg-green-600 text-white font-medium text-sm rounded-full hover:bg-green-700 transition-colors"
          >
            Retourner à l'accueil
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <svg className="w-10 h-10 text-green-600 animate-spin mx-auto mb-4" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p className="text-gray-700 font-medium">Connexion en cours...</p>
        <p className="text-sm text-gray-500 mt-1">Veuillez patienter</p>
      </div>
    </div>
  )
}
